import React, {ReactNode} from 'react'

import Alert from '../feedback/Alert.js'
import {popupStyle} from './styles.js'

interface AlertStackProps {
    message?: ReactNode
    info?: ReactNode
    warning?: ReactNode
    warnings?: ReactNode[]
    error?: ReactNode
    errors?: ReactNode[]
}

/**
 * The messages of a popup below each other, in the order success, info, warning(s), error(s), each with the alert gap
 * below it. Empty ones are left out. No wrapper element, so it doesn't change the layout it is placed in.
 */
export default function AlertStack({message, info, warning, warnings = [], error, errors = []}: AlertStackProps) {
    const alerts: {variant: 'success' | 'info' | 'warning' | 'error', content: ReactNode, key: string}[] = [
        {variant: 'success', content: message, key: 'message'},
        {variant: 'info', content: info, key: 'info'},
        {variant: 'warning', content: warning, key: 'warning'},
        ...warnings.map((content, index) => ({variant: 'warning' as const, content, key: `warning${index}`})),
        {variant: 'error', content: error, key: 'error'},
        ...errors.map((content, index) => ({variant: 'error' as const, content, key: `error${index}`}))
    ]

    return (
        <>
            {alerts.filter(({content}) => content).map(({variant, content, key}) => (
                <Alert key={key} variant={variant} style={{marginBottom: popupStyle.alertGap}}>{content}</Alert>
            ))}
        </>
    )
}
